<template>
    <div class="container">
        <TitleInfo title="对企课程推荐" :tip="tip1" icon="one-live"  v-if="classListInfo.moduleNumbers.course"></TitleInfo>
        <div class="items">
            <EntCourseItem :items="classListInfo.results" v-if="!$router.currentRoute.query.keyword"/>
            <ClassSearchResult :items="classListInfo.results" v-if="$router.currentRoute.query.keyword"/>
            <Waiting v-if="!classListInfo.moduleNumbers.course&&!loading"/>
        </div>
        <Page :total="classListInfo.moduleNumbers.course"
              v-if="classListInfo.moduleNumbers.course"
              :current="filterParams.pageIndex*1"
              :page-size="filterParams.pageSize"
              @on-change="handlePageIndexChanged"/>
        <Spin size="large" fix v-if="loading"></Spin>


    </div>
</template>

<script>
    import api from '@/api/calss-search'
    import EntCourseItem from "../components/EntCourseItem";
    import ClassSearchResult from "../components/ClassSearchResult";
    import Empty from "../../class-search-result/empty"
    import TitleInfo from "../components/TitleInfo";
    import Waiting from "../../service-center/Waiting"

    export default {
        name: "EntCourse",
        data() {
            return {
                loading:false,
                tip1:'讲课，是律师开拓市场最优雅的方式。这里的课程，不定位专业法律知识的传播，而定位为激发客户的法律服务需求，推动客户与律师产生链接，建立更强信任。',
                filterParams: {
                    query: this.$router.currentRoute.query.keyword,
                    pageIndex: this.$router.currentRoute.query.pageIndex||1,
                    pageSize: 6,
                    searchType: 'course',
                    secondType:'enterpriseCourse'
                },
                classListInfo:{
                    results:[],
                    moduleNumbers:{},
                    courseTotal:0,
                },
                totalCount: 0,
                searchTitle: '',
                pageIndex: this.$router.currentRoute.query.pageIndex||0,
                courses: []
            }
        },
        watch: {
            $route(to, from) {
                this.filterParams.query = this.$router.currentRoute.query.keyword
                this.filterParams.pageIndex = this.$router.currentRoute.query.pageIndex
                this.filterParams.pageSize = 6
                this.queryList()
            }
        },
        components: {EntCourseItem,Empty,ClassSearchResult,TitleInfo,Waiting},
        methods: {
            // 查询数据
            async queryList() {
                this.loading = true
                api.classSearchList(this.filterParams).then(res => {
                    this.loading = false
                    this.classListInfo = res
                }).finally(() => {
                    this.loading = false
                })
            },
            handlePageIndexChanged(index) {
                this.filterParams.pageIndex = index;
                this.$router.push(`${this.$router.currentRoute.path}?keyword=${this.$router.currentRoute.query.keyword||''}&pageIndex=${index}`)
            }
        },
        mounted() {
            this.queryList();
            window.scrollTo(0, 0)
        }
    }
</script>

<style scoped lang="scss">
    .container {
        width: 1000px;
        padding: 40px 0px 40px 0px;
        margin-left: 45px;
    }
    .totalCount {
        height: 20px;
        margin-left: 10px;
        font-family: PingFangSC;
        font-size: 14px;
        margin-bottom: 32px;
        color: #4a4a4a;
    }
    .items{
        overflow: hidden;
        margin-bottom: 20px;
    }
    .pagination {
        clear: both;
    }
</style>
